var _path, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendarCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    "data-name": "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "calendar-1",
    d: "M0,13.24H60.23V0H75.32V13.24h45.14V0h15.08V13.24h45.14V1.32h15.09V13.24H256V256H0ZM15.09,70.7V240.91H240.91V70.7Zm0-42.37V55.61H240.91V28.33H195.77V41.57H180.68V28.33H135.54V41.57H120.46V28.33H75.32V41.57H60.23V28.33Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "calendar-1",
    points: "57.82 164.85 68.47 154.21 105.74 191.47 199.77 97.44 210.42 108.09 105.74 212.77 57.82 164.85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarCheck);
export default __webpack_public_path__ + "static/media/icon-calendar-check.ac392b2a.svg";
export { ForwardRef as ReactComponent };